import React from 'react';

function Page404() {
	const containerStyle = {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        background: '#fff',
        fontSize: '30px'
	};
	return (
		<div style={containerStyle}>Page not found</div>
	);
};

export default Page404;